/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import { Button, InputSelect, Label, Modal, CustomLoading, Input, InputCheckbox, SaveIcon } from "../../../../Components";

/* 🔗 SERVICE */
import { PartsComandServices } from "../../../../Services/partscommandService";

/* 🧠 REDUX */
import { store } from "../../../../Redux/Store";
import { changeModal } from "../../../../Redux/Actions";

/* 🎨 STYLES */
import { Container, CountContainer, LineTitle, TitleText, LineList, ListText, PageTitle, ContainerList, 
    ContainerHead, ContainerRow, ButtonsContainer, ContainerColumn} from "./styles";

/* 🔧 UTILS */
import { isValidField } from "../../../../util/validate";

const ListPartCommandsVariablesAcceptUnits = () => {
    const { t } = useTranslation();

    document.title = "Unidades de medida";
    const Services = useRef(new PartsComandServices());
    const [partCommands, setPartCommands] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [parts, setParts] = useState([]);

    const partCommandField = useRef();
    const nameField = useRef();
    const customUnitField = useRef();
    const proportionField = useRef();

    const partCommandValue = useRef();
    const nameValue = useRef();
    const customUnitValue = useRef();
    const proportionValue = useRef();
    const isActiveValue = useRef(false);

    useEffect(() => {
        async function getUnits(){
            let currentList = await Services.current.getUnits();
            setPartCommands(currentList)
            setIsLoading(false)
        }

        async function getPartCommand(){
            let currentItem = await Services.current.getPartCommandsVariables();
            setParts(currentItem);
        }

        getUnits();
        getPartCommand();
    }, []);

    // Salva as edições do usuário
    async function Save(){
        store.dispatch(changeModal(''))
        if(isValidField(partCommandValue.current) && isValidField(nameValue.current) && isValidField(proportionValue.current)){

            let form = new FormData();
            if(partCommandValue.current){form.append('command_variable', partCommandValue.current)}
            if(customUnitValue.current){form.append('custom_unit', customUnitValue.current)}
            if(nameValue.current){form.append('name', nameValue.current)}
            if(proportionValue.current){form.append('proportion', proportionValue.current)}
            form.append('isactive', isActiveValue.current ? 1 : 0)

    
            await Services.current.SaveUnit(form)
        }else{
            toast(t("message.save"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }

    return(
        <>
            <Container>
                <PageTitle>
                    Unidades de medida
                </PageTitle>

                <ContainerHead>
                    <CountContainer>
                        {t("administrative.sub-items.list-total") + " " + partCommands.length + " Unidades" }
                    </CountContainer>

                    <Button onClick={()=>store.dispatch(changeModal('newPartCommand'))} width={'fit-content'} color={'green'} icon={''} text={"+ Criar nova unidade"}></Button>
                </ContainerHead>

                <ContainerList>
                    <LineTitle>
                        <TitleText>Nome</TitleText>
                        <TitleText>Variável</TitleText>
                    </LineTitle>

                    {isLoading?
                        <CustomLoading width={'150px'} height={'150px'}/>
                    :
                        partCommands?.map((item, index)=>(
                            <LineList key={index} href={`/PartCommandsVariablesAcceptUnits/${item.id}`}>
                                <ListText>{item.name}</ListText>
                                <ListText>{item.command_variable_name}</ListText>
                            </LineList>
                        ))
                    }
                </ContainerList>
            </Container>
            
            <Modal title={"Cadastrar Unidade"} name={'newPartCommand'} width={'70%'} height={'90%'} >
                
                <ContainerRow onSubmit={(e)=> e.preventDefault()}>
                    <ContainerColumn>
                        <Label text={"Variável"} aling="flex-start"/>
                        <InputSelect
                            key={'variable'}
                            name={'variable'}
                            id={'variable'}
                            placeholder={"Variável"}
                            invalidMessage = {"Variável!"}
                            options={parts}
                            innerRef={partCommandField}
                            validationFunction = {(value) => isValidField(value)}
                            onchange={(value) => partCommandValue.current = value}>
                        </InputSelect>      

                        <Label text={"Nome"} aling="flex-start"/>
                        <Input
                            key={'name'}
                            name={'name'}
                            id={'name'}
                            placeholder={"Nome"}
                            invalidMessage = {"Nome inválida!"}
                            innerRef={nameField}
                            validationFunction = {(value) => isValidField(value)}
                            onchange={(value) => nameValue.current = value}>
                        </Input>                
                    </ContainerColumn>

                    <ContainerColumn>
                        <Label text={"Unidade"} aling="flex-start"/>
                        <Input
                            key={'unit'}
                            name={'unit'}
                            id={'unit'}
                            placeholder={"Unidade"}
                            invalidMessage = {"Unidade inválida!"}
                            innerRef={customUnitField}
                            validationFunction = {(value) => isValidField(value)}
                            onchange={(value) => customUnitValue.current = value}>
                        </Input>

                        <Label text={"Proporção"} aling="flex-start"/>
                        <Input
                            key={'proportion'}
                            name={'proportion'}
                            id={'proportion'}
                            type={'Number'}
                            placeholder={"Proporção"}
                            invalidMessage = {"Proporção inválida!"}
                            innerRef={proportionField}
                            validationFunction = {(value) => isValidField(value)}
                            onchange={(value) => proportionValue.current = value}>
                        </Input>

                        <InputCheckbox text={t("inputs.isActive.label")} onChange={(value)=> {isActiveValue.current = value; return true}}/>
                    </ContainerColumn>
                </ContainerRow>

                
                <ButtonsContainer>
                    <Button text={t("buttons.save")} width={'150px'} icon={<SaveIcon/>} onClick={()=>Save()}/>
                    <Button text={t("buttons.cancel")} width={'150px'} color={'white-red'} onClick={()=>store.dispatch(changeModal(''))}/>
                </ButtonsContainer>
            </Modal>
        </>
    )
}

export default ListPartCommandsVariablesAcceptUnits;